import { z as zod } from "zod";
import { HeroIntroSchema } from "@/app/features/shared/intros/hero/types/HeroIntro.schema";
import { MediaRefSchema } from "@/app/features/shared/__to_be_integrated/types/forms/MediaRefSchema";
import { LinkSchema } from "@/app/features/shared/__to_be_integrated/types/forms/LinkSchema";

const GuidedTourExhibitionSchema = zod.object({
    documentId: zod.string(),
});

const GuidedTourTileSchema = zod.object({
    id: zod.string(),
    title: zod.string(),
    subtitle: zod.string().nullish(),
    description: zod.string(),
    order: zod.number(),
    image: MediaRefSchema,
    link: LinkSchema.nullish(),
    exhibition: GuidedTourExhibitionSchema.nullish(),
});

export const SiteGuidedToursSchema = zod.object({
    intro: HeroIntroSchema,
    tours: zod.array(GuidedTourTileSchema),
});

export type SiteGuidedToursEditable = zod.infer<typeof SiteGuidedToursSchema>;
export type GuidedTourTileEditable = zod.infer<typeof GuidedTourTileSchema>;